/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntitySearchColumn } from './entitySearchColumn';


export interface EntitySearchResponse { 
    rows?: Array<Array<EntitySearchColumn>>;
}

